import { FC, useContext, useEffect, useState } from "react";

import Accordion from "shared/ui/Accordion";
import DocumentDetails from "features/documents/components/DocumentDetails";
import { DocumentUnion } from "shared/types/types";
import { DocumentsContext } from "features/documents";
import { ReactComponent as IconReturn } from "assets/img/icons/icon_arrow-Left.svg";
import { ReactComponent as IconRight } from "assets/img/icons/icon_arrow-Right.svg";
import NotificationsList from "components/NotificationsList";
import PageHeader from "components/PageHeader";
import faqs from "assets/dataTests/FAQ.json";
import { formatTypeDocument } from "assets/functions";
import { useNavigate } from "react-router-dom";

const Document: FC = () => {
    const [currentDocument, setCurrentDocument] = useState<DocumentUnion | undefined>(undefined);
    const [currentFaqs, setCurrentFaqs] = useState<any[]>([]);
    const navigate = useNavigate();
    const { allDocuments } = useContext(DocumentsContext);

    useEffect(() => {
        const id = getCurrentDocumentId();
        const currentDocument = allDocuments.find((item) => item.id === id);
        setCurrentDocument(currentDocument);

        if (currentDocument && currentDocument.type) {
            setCurrentFaqs(faqs?.filter((faq) => faq.type === currentDocument.type.toLowerCase())[0]?.faqs);
        }
    }, [allDocuments]);

    const getCurrentDocumentId = (): number => {
        const url = window.location.href;
        const idString = url.substring(url.lastIndexOf("/") + 1);
        const idNumber = parseInt(idString, 10);
        return idNumber;
    };

    const handleReturn = () => {
        navigate(-1);
    };

    if (!currentDocument) {
        return null; // or render a loading state
    }

    return (
        <>
            <PageHeader
              title={"Pièces d'identité"}
              description={formatTypeDocument(currentDocument.type)}
              showBackBtn={true}
              protectAlert={true}
              notification={true}
            >
            </PageHeader>
            <div className="content__body">
                <IconReturn
                    fill="#5E89C2"
                    width="28px"
                    onClick={handleReturn}
                    className="pointer"
                />
                <div className="row">
                    <div className="col-lg-12">
                        <DocumentDetails document={currentDocument && currentDocument} />
                        <h4>FAQ</h4>
                        {currentFaqs?.map((faq, index) => (
                            <Accordion
                                title={faq.question}
                                key={index}>
                                <div dangerouslySetInnerHTML={{ __html: faq.answer }} />
                            </Accordion>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Document;
